var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTop1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    rx: 8,
    fill: "url(#paint0_linear_581_477)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5978 35.4535L45.4986 19.7877C45.1978 19.4556 44.778 19.2676 44.3331 19.2676H34.9336C34.3163 19.2676 33.7555 19.631 33.5017 20.195C33.2511 20.7621 33.3545 21.4232 33.768 21.8806L46.9242 36.5L33.768 51.1162C33.3545 51.5768 33.2479 52.2379 33.5017 52.8018C33.7555 53.3689 34.3163 53.7324 34.9336 53.7324H44.3331C44.778 53.7324 45.1978 53.5413 45.4986 53.2154L59.5978 37.5496C60.1336 36.9543 60.1336 36.0457 59.5978 35.4535Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2326 35.4535L25.1334 19.7877C24.8326 19.4556 24.4127 19.2676 23.9678 19.2676H14.5683C13.9511 19.2676 13.3903 19.631 13.1365 20.195C12.8858 20.7621 12.9892 21.4232 13.4028 21.8806L26.559 36.5L13.4028 51.1162C12.9892 51.5768 12.8827 52.2379 13.1365 52.8018C13.3903 53.3689 13.9511 53.7324 14.5683 53.7324H23.9678C24.4127 53.7324 24.8326 53.5413 25.1334 53.2154L39.2326 37.5496C39.7684 36.9543 39.7684 36.0457 39.2326 35.4535Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_581_477",
    x1: 4.5,
    y1: 4,
    x2: 70,
    y2: 71.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#981A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTop1);
export default __webpack_public_path__ + "static/media/icon_top1.929ed2df2b80eb9a9a295e44468bfba2.svg";
export { ForwardRef as ReactComponent };